export const EMAIL_CAPTURE_TRANSITION = {duration: 0.25, ease: 'easeOut'} as const

export const EMAIL_CAPTURE_FADE_VARIANTS = {
  initial: {opacity: 0, y: 8},
  animate: {opacity: 1, y: 0},
  exit: {opacity: 0, y: -8},
}
